// extracted by mini-css-extract-plugin
module.exports = {"section":"I_CA_section___CfUr"};